export default {"src":"/_next/static/media/landmarkIcon.3d4de9c6.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};